// extracted by mini-css-extract-plugin
export default {"wrapper":"BookkeepingHeader_wrapper__5+vPV","title":"BookkeepingHeader_title__dDiSV","dateRange":"BookkeepingHeader_dateRange__Io9d+"};